import type {
  ResidentAddress,
  ResidentAddressKind,
  ResidentAddressSourceChannel,
  ResidentSummary,
} from "@/api/residents";

export const RESIDENT_ADDRESS_KIND_LABELS: Record<ResidentAddressKind, string> = {
  home: "Home",
  mailing: "Mailing",
  property: "Property",
  project_site: "Project site",
  other: "Other",
};

export const RESIDENT_ADDRESS_SOURCE_LABELS: Record<ResidentAddressSourceChannel, string> = {
  staff_manual: "Added manually",
  complaint: "From concern",
  permit: "From permit",
  backfill: "Imported",
  import: "Bulk import",
  email: "From email",
  connect_form: "Connect form",
  api: "API",
};

export function residentListMeta(resident: ResidentSummary): string | null {
  const parts: string[] = [];
  if (resident.email) parts.push(resident.email);
  if (resident.phone) parts.push(resident.phone);
  return parts.length > 0 ? parts.join(" · ") : null;
}

export function residentAddressLine(address: ResidentAddress): string {
  const parts = [
    address.address_line1,
    address.address_line2,
    [address.city, address.state].filter(Boolean).join(", "),
    address.postal_code,
  ].filter(Boolean);

  if (parts.length > 0) {
    return parts.join(", ");
  }

  const data = address.address_data;
  if (data && typeof data === "object") {
    const formatted = data.formatted_address ?? data.address;
    if (typeof formatted === "string" && formatted.trim()) {
      return formatted.trim();
    }
  }

  return "Address on file";
}

export function residentSourceChannelLabel(channel: ResidentAddressSourceChannel): string {
  return RESIDENT_ADDRESS_SOURCE_LABELS[channel] ?? channel;
}
